import './BottomNavBar.scss';
import cls from 'classnames';

import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { useSelectActiveProduct, useTrans } from '../../core/hooks';
import {
  selectActiveProductType,
  selectProductTypeFilterOption,
} from '../../core/redux/features/products/reducers/productTypes';
import { AppState } from '../../core/redux/reducers';


function BottomNavBar() {
  let location = useLocation();
  let trans = useTrans();

  const NAV_ITEMS = [
    {
      id: 'home',
      label: trans('home'),
      icon: 'eb-icon-explore-black',
      link: '/',
      reload: true,
    },
  ];
  
  let [navItems, setNavItems] = React.useState(NAV_ITEMS);
  const productTypes = useSelector(selectProductTypeFilterOption);

  let getActiveId = (items = navItems) =>
    items.find(item => item.link === location.pathname)?.id;

  let [activeId, setActiveId] = React.useState(getActiveId);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    let items = [
      ...NAV_ITEMS,
      ...productTypes.map(item => ({
        id: item.id,
        label: item.label,
        icon: item.icon,
        link: item.route,
        reload: true,
      })),
    ];
    setNavItems(items);

    let findId = getActiveId(items);

    console.log(findId);
    if (findId) {
      setActiveId(findId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productTypes]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    let findId = getActiveId();

    if (findId) {
      setActiveId(findId);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  // bottom nav bar with links and label to home, restaurants, take away and bars
  return createPortal(
    <div className="bottom-nav-bar">
      {navItems.map(item => {
        return (
          <Link
            key={item.link}
            to={item.link}
            className={cls(
              'bottom-nav-bar__item',
              activeId === item.id && 'bottom-nav-bar__item--active',
            )}
            onClick={e => {
              e.preventDefault();

              setActiveId(item.id);
              if (item.reload) {
                window.location.href = item.link;
              }
            }}
          >
            <span className="bottom-nav-bar__icon">
              <i className={`eb ${item.icon}`}></i>
            </span>
            <span className="bottom-nav-bar__label">{item.label}</span>
          </Link>
        );
      })}
    </div>,
    document.body,
  );
}

export default BottomNavBar;
